import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withKeys as _withKeys, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "agp-head" }
const _hoisted_2 = { class: "agp-title" }
const _hoisted_3 = {
  key: 0,
  class: "agp-sub"
}
const _hoisted_4 = {
  key: 1,
  class: "agp-sub"
}
const _hoisted_5 = { class: "agp-body" }
const _hoisted_6 = {
  key: 0,
  class: "agp-muted"
}
const _hoisted_7 = {
  key: 1,
  class: "agp-problem"
}
const _hoisted_8 = {
  key: 2,
  class: "agp-warn"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "agp-grid" }
const _hoisted_11 = { class: "agp-field agp-wide" }
const _hoisted_12 = { class: "agp-field agp-wide" }
const _hoisted_13 = { class: "agp-field" }
const _hoisted_14 = { class: "agp-field" }
const _hoisted_15 = { class: "agp-field agp-wide" }
const _hoisted_16 = { value: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "agp-row" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "agp-cands"
}
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = { class: "agp-sec-head" }
const _hoisted_24 = { class: "agp-field agp-wide" }
const _hoisted_25 = { class: "agp-field" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "agp-field" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "agp-field" }
const _hoisted_30 = { class: "agp-row agp-wide" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 1,
  class: "agp-muted"
}
const _hoisted_33 = { class: "agp-deal-top" }
const _hoisted_34 = { class: "agp-deal-meta" }
const _hoisted_35 = ["aria-label"]
const _hoisted_36 = ["disabled", "title", "onClick"]
const _hoisted_37 = { class: "agp-row" }
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 1,
  class: "agp-row"
}
const _hoisted_43 = ["id"]
const _hoisted_44 = ["value"]
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = { class: "agp-sec-head" }
const _hoisted_47 = { class: "agp-row agp-row--tight" }
const _hoisted_48 = { class: "agp-field" }
const _hoisted_49 = { class: "agp-field" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "agp-field agp-wide" }
const _hoisted_52 = { value: "" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "agp-field agp-wide" }
const _hoisted_55 = { class: "agp-row agp-wide" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "agp-field agp-wide" }
const _hoisted_58 = { class: "agp-row agp-wide" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 2,
  class: "agp-muted"
}
const _hoisted_61 = { class: "agp-tasks" }
const _hoisted_62 = { class: "agp-task-when" }
const _hoisted_63 = { class: "agp-task-text" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "agp-muted" }
const _hoisted_66 = { class: "agp-row" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 1,
  class: "agp-muted"
}
const _hoisted_69 = { class: "agp-row" }
const _hoisted_70 = ["value"]
const _hoisted_71 = ["disabled"]
const _hoisted_72 = {
  key: 0,
  class: "agp-foot"
}
const _hoisted_73 = ["href"]
const _hoisted_74 = ["disabled"]
const _hoisted_75 = ["disabled"]

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import { usePermission } from '@/composables/usePermission'
import type { AgendorPanelFocus, AgendorPanelState } from '@/composables/useAgendorPanel'
import { setAgendorLink } from '@/composables/useAgendor'
import { assignConversation } from '@/services/wootdashConversations'
import {
  AGENDOR_TASK_TYPES, createAgendorDeal, createAgendorPerson, createAgendorTask, findAgendorContact, linkAgendorPerson, moveAgendorDeal,
  setAgendorDealStatus, setAgendorOwner, unlinkAgendorContact, type AgendorDeal, type AgendorDealStatus, type AgendorPerson, type AgendorStage,
} from '@/services/wootdashAgendor'


export default /*@__PURE__*/_defineComponent({
  __name: 'AgendorPanel',
  props: {
    state: {},
    contactId: {},
    conversationId: {},
    conversationAgentId: {},
    contactName: {},
    focus: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

// Painel do Agendor na conversa (plano-agendor.md, fase 4): enviar/procurar, negócios (criar, linha de etapas, ganho
// e perdido), retornos e anotações, responsável (assumir/passar) e o aviso quando quem atende não é o dono do lead.
// Mover etapa e ganho/perda respeitam as permissões agendor.mover_etapa e agendor.ganho_perda.
const props = __props
const emit = __emit

const STATUS_LABEL: Record<AgendorDealStatus, string> = { ongoing: 'Em andamento', won: 'Ganho', lost: 'Perdido' }

const store = useStore()
const { can } = usePermission()
const token = computed<string>(() => store.getters.authUser?.wootdash_token ?? '')
const myAgentId = computed<string>(() => store.getters.authUser?.wootdash_agent_id ?? '')
const canMove = computed(() => can('agendor.mover_etapa'))
const canWinLose = computed(() => can('agendor.ganho_perda'))

const panel = computed(() => props.state.panel.value)
const link = computed(() => panel.value?.link ?? null)
const busy = computed(() => props.state.busy.value)
const myName = computed(() => panel.value?.users.find(u => u.id === panel.value?.myUserId)?.name ?? null)
const otherUsers = computed(() => (panel.value?.users ?? []).filter(u => u.name !== link.value?.ownerName))
const divergence = computed(() => !!link.value?.ownerName && !!panel.value?.ownerAgentId && !!props.conversationAgentId
  && props.conversationAgentId.toLowerCase() === myAgentId.value.toLowerCase() && panel.value.ownerAgentId.toLowerCase() !== myAgentId.value.toLowerCase())

const openForm = ref<'deal' | 'task' | 'note' | null>(null)
const losing = ref<string | null>(null)
const lossReason = ref('')
const passTo = ref('')
const note = ref('')
const candidates = ref<AgendorPerson[]>([])
const send = reactive({ nome: props.contactName ?? '', email: '', empresa: '', cnpj: '', responsavelId: '' })
const deal = reactive({ titulo: '', funilId: '', etapa: 1, valor: '' })
const task = reactive({ vencimento: '', tipo: 'LIGACAO', responsavelId: '', texto: '' })

const root = ref<HTMLElement | null>(null)
const secSend = ref<HTMLElement | null>(null)
const secDeal = ref<HTMLElement | null>(null)
const secTask = ref<HTMLElement | null>(null)
const secOwner = ref<HTMLElement | null>(null)

function stagesOf(funnelId: string | null): AgendorStage[] {
  return panel.value?.funnels.find(f => f.id === funnelId)?.stages ?? []
}

function resetDeal() {
  deal.titulo = `${props.contactName ?? 'Contato'} — WhatsApp`
  deal.funilId = panel.value?.defaultFunnelId ?? panel.value?.funnels[0]?.id ?? ''
  deal.etapa = panel.value?.defaultStageSequence ?? stagesOf(deal.funilId)[0]?.sequence ?? 1
  deal.valor = ''
}

/** Amanhã às 9h, no fuso do navegador (input datetime-local). */
function tomorrowAtNine() {
  const d = new Date()
  d.setDate(d.getDate() + 1)
  d.setHours(9, 0, 0, 0)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T09:00`
}

function applyFocus(focus: AgendorPanelFocus | undefined) {
  if (focus === 'deal' || focus === 'task' || focus === 'note') openForm.value = focus
  if (focus === 'deal') resetDeal()
  if (focus === 'task' && !task.vencimento) task.vencimento = tomorrowAtNine()
  void nextTick(() => {
    const target = { send: secSend, deal: secDeal, task: secTask, note: secTask, owner: secOwner }[focus ?? 'send']?.value
    target?.scrollIntoView({ block: 'start', behavior: 'smooth' })
    target?.querySelector<HTMLElement>('input, textarea, select, button')?.focus()
  })
}

onMounted(() => { applyFocus(props.focus); if (!props.focus) root.value?.querySelector<HTMLElement>('button')?.focus() })
watch(() => props.focus, f => applyFocus(f))
watch(panel, p => { if (p && !deal.funilId) resetDeal() }, { immediate: true })
watch(openForm, f => {
  if (f === 'deal') resetDeal()
  if (f === 'task' && !task.vencimento) task.vencimento = tomorrowAtNine()
})

const conv = () => props.conversationId

async function doSend() {
  const ok = await props.state.run(() => createAgendorPerson(token.value, props.contactId, conv(), {
    nome: send.nome.trim(), email: send.email.trim() || null, empresa: send.empresa.trim() || null, cnpj: send.cnpj.trim() || null,
    responsavelId: send.responsavelId || null,
  }))
  if (ok) openForm.value = null
}

async function doFind() {
  const result = await findAgendorContact(token.value, props.contactId, conv())
  const match = result.match
  candidates.value = match?.outcome === 'Ambiguous' ? match.candidates ?? [] : []
  if (match?.outcome === 'Linked' || match?.outcome === 'AlreadyLinked') {
    setAgendorLink(props.contactId, match.link)
    await props.state.load()
  } else {
    props.state.setProblem(result.problem ?? match?.problem ?? (match?.outcome === 'NotFound' ? 'Ninguém no Agendor com o telefone deste contato. Use "Enviar para o Agendor".' : null))
  }
}

async function doChoose(personId: string) {
  const result = await linkAgendorPerson(token.value, props.contactId, personId, conv())
  if (result.match?.link) {
    setAgendorLink(props.contactId, result.match.link)
    candidates.value = []
    await props.state.load()
  } else {
    props.state.setProblem(result.problem)
  }
}

async function doCreateDeal() {
  const value = deal.valor.trim() ? Number(deal.valor.replace(/\./g, '').replace(',', '.')) : null
  if (value !== null && (!Number.isFinite(value) || value < 0)) { props.state.setProblem('Valor inválido.'); return }
  const ok = await props.state.run(() => createAgendorDeal(token.value, props.contactId, conv(), { titulo: deal.titulo.trim(), funilId: deal.funilId, etapa: deal.etapa, valor: value }))
  if (ok) openForm.value = null
}

function doMove(d: AgendorDeal, s: AgendorStage) {
  void props.state.run(() => moveAgendorDeal(token.value, props.contactId, conv(), d.id, d.funnelId!, s.sequence))
}

async function doStatus(d: AgendorDeal, status: AgendorDealStatus) {
  if (status === 'won') {
    const ok = await Swal.fire({ title: 'Marcar como ganho?', text: `"${d.title}" vira ganho no Agendor e a conversa ganha a etiqueta de cliente.`, icon: 'question',
      showCancelButton: true, confirmButtonText: 'Marcar ganho', cancelButtonText: 'Cancelar' })
    if (!ok.isConfirmed) return
  }
  const done = await props.state.run(() => setAgendorDealStatus(token.value, props.contactId, conv(), d.id, status, status === 'lost' ? lossReason.value : null))
  if (done) { losing.value = null; lossReason.value = '' }
}

async function doTask(withDue: boolean) {
  const ok = await props.state.run(() => createAgendorTask(token.value, props.contactId, conv(), withDue
    ? { texto: task.texto.trim(), vencimento: new Date(task.vencimento).toISOString(), tipo: task.tipo || null, responsavelId: task.responsavelId || null }
    : { texto: note.value.trim() }))
  if (!ok) return
  openForm.value = null
  if (withDue) { task.texto = ''; task.vencimento = '' } else note.value = ''
}

async function doOwner(userId: string | null) {
  const target = userId ? panel.value?.users.find(u => u.id === userId) : null
  const ok = await props.state.run(() => setAgendorOwner(token.value, props.contactId, conv(), userId))
  if (!ok) return
  passTo.value = ''
  // Passou pra alguém que também é agente aqui: oferece levar a conversa junto.
  if (target?.agentId && props.conversationId && target.agentId.toLowerCase() !== (props.conversationAgentId ?? '').toLowerCase()) {
    const ask = await Swal.fire({ title: `Transferir a conversa para ${target.name} também?`, text: 'O lead já é dele no Agendor.', icon: 'question',
      showCancelButton: true, confirmButtonText: 'Transferir', cancelButtonText: 'Só o lead' })
    if (ask.isConfirmed) await transferTo(target.agentId, target.name)
  }
}

async function transferTo(agentId: string, name: string) {
  if (!props.conversationId) return
  const ok = await assignConversation(token.value, props.conversationId, agentId)
  props.state.setProblem(ok ? null : `Não deu pra transferir a conversa para ${name}.`)
}

async function doRefresh() {
  await findAgendorContact(token.value, props.contactId, conv())
  await props.state.load(true)
}

async function doUnlink() {
  if (!link.value) return
  const ok = await Swal.fire({ title: 'Desvincular do Agendor?', text: `O contato deixa de estar ligado a ${link.value.personName}. Nada é apagado no Agendor.`,
    icon: 'warning', showCancelButton: true, confirmButtonText: 'Desvincular', cancelButtonText: 'Cancelar' })
  if (!ok.isConfirmed) return
  const result = await unlinkAgendorContact(token.value, props.contactId, conv())
  if (result.problem) { props.state.setProblem(result.problem); return }
  setAgendorLink(props.contactId, null)
  await props.state.load()
}

function firstName(name: string | null | undefined) { return (name ?? '').split(' ')[0] || 'ele' }
function money(value: number) { return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }
function when(iso: string) {
  return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "agp-backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("aside", {
      ref_key: "root",
      ref: root,
      class: "agp",
      role: "dialog",
      "aria-label": "Agendor",
      onKeydown: _cache[27] || (_cache[27] = _withKeys(($event: any) => (emit('close')), ["esc"]))
    }, [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "agp-brand" }, "Agendor", -1)),
          _createElementVNode("h2", _hoisted_2, _toDisplayString(link.value?.personName ?? __props.contactName ?? 'Contato'), 1),
          (link.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString([link.value.organizationName, link.value.ownerName ? `responsável ${link.value.ownerName}` : 'sem responsável'].filter(Boolean).join(' · ')), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Ainda não está no Agendor"))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "agp-x",
          "aria-label": "Fechar",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_5, [
        (__props.state.loading.value && !panel.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Carregando o Agendor…"))
          : _createCommentVNode("", true),
        (__props.state.problem.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.state.problem.value), 1))
          : _createCommentVNode("", true),
        (divergence.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, [
                _cache[29] || (_cache[29] = _createTextVNode("Você está atendendo, mas o lead é de ", -1)),
                _createElementVNode("b", null, _toDisplayString(link.value?.ownerName), 1),
                _cache[30] || (_cache[30] = _createTextVNode(".", -1))
              ]),
              (__props.conversationId && panel.value?.ownerAgentId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "agp-btn agp-btn--sm",
                    disabled: busy.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (transferTo(panel.value!.ownerAgentId!, link.value?.ownerName ?? '')))
                  }, " Transferir a conversa pra " + _toDisplayString(firstName(link.value?.ownerName)), 9, _hoisted_9))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (panel.value && !link.value)
          ? (_openBlock(), _createElementBlock("section", {
              key: 3,
              ref_key: "secSend",
              ref: secSend,
              class: "agp-sec"
            }, [
              _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Enviar para o Agendor", -1)),
              _cache[37] || (_cache[37] = _createElementVNode("p", { class: "agp-muted" }, "Procura antes pelo telefone: se a pessoa já estiver lá, só vincula.", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _cache[31] || (_cache[31] = _createElementVNode("span", null, "Nome", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "agp-name",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((send.nome) = $event)),
                    class: "agp-input"
                  }, null, 512), [
                    [_vModelText, send.nome]
                  ])
                ]),
                _createElementVNode("label", _hoisted_12, [
                  _cache[32] || (_cache[32] = _createElementVNode("span", null, "E-mail", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "agp-email",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((send.email) = $event)),
                    class: "agp-input",
                    type: "email",
                    placeholder: "opcional"
                  }, null, 512), [
                    [_vModelText, send.email]
                  ])
                ]),
                _createElementVNode("label", _hoisted_13, [
                  _cache[33] || (_cache[33] = _createElementVNode("span", null, "Empresa", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "agp-org",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((send.empresa) = $event)),
                    class: "agp-input",
                    placeholder: "opcional"
                  }, null, 512), [
                    [_vModelText, send.empresa]
                  ])
                ]),
                _createElementVNode("label", _hoisted_14, [
                  _cache[34] || (_cache[34] = _createElementVNode("span", null, "CNPJ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "agp-cnpj",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((send.cnpj) = $event)),
                    class: "agp-input",
                    inputmode: "numeric",
                    placeholder: "opcional"
                  }, null, 512), [
                    [_vModelText, send.cnpj]
                  ])
                ]),
                _createElementVNode("label", _hoisted_15, [
                  _cache[35] || (_cache[35] = _createElementVNode("span", null, "Responsável", -1)),
                  _withDirectives(_createElementVNode("select", {
                    id: "agp-send-owner",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((send.responsavelId) = $event)),
                    class: "agp-input"
                  }, [
                    _createElementVNode("option", _hoisted_16, _toDisplayString(panel.value.myUserId ? 'Eu' : 'Sem responsável'), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.users, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.id,
                        value: u.id
                      }, _toDisplayString(u.name), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, send.responsavelId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "agp-btn agp-btn--main",
                  disabled: busy.value || !send.nome.trim(),
                  onClick: doSend
                }, "Enviar para o Agendor", 8, _hoisted_19),
                _createElementVNode("button", {
                  type: "button",
                  class: "agp-btn",
                  disabled: busy.value,
                  onClick: doFind
                }, "Procurar pelo telefone", 8, _hoisted_20)
              ]),
              (candidates.value.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidates.value, (c) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: c.id
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "agp-cand",
                          disabled: busy.value,
                          onClick: ($event: any) => (doChoose(c.id))
                        }, [
                          _createElementVNode("b", null, _toDisplayString(c.name), 1),
                          _createElementVNode("small", null, _toDisplayString([c.organizationName, c.ownerName ? `resp. ${c.ownerName}` : null].filter(Boolean).join(' · ') || `id ${c.id}`), 1)
                        ], 8, _hoisted_22)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        (panel.value && link.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("section", {
                ref_key: "secDeal",
                ref: secDeal,
                class: "agp-sec"
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Negócios", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "agp-link",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (openForm.value = openForm.value === 'deal' ? null : 'deal'))
                  }, _toDisplayString(openForm.value === 'deal' ? 'Cancelar' : '+ Criar negócio'), 1)
                ]),
                (openForm.value === 'deal')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      class: "agp-form",
                      onSubmit: _withModifiers(doCreateDeal, ["prevent"])
                    }, [
                      _createElementVNode("label", _hoisted_24, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", null, "Título", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "agp-deal-title",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((deal.titulo) = $event)),
                          class: "agp-input",
                          required: ""
                        }, null, 512), [
                          [_vModelText, deal.titulo]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_25, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", null, "Funil", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "agp-deal-funnel",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((deal.funilId) = $event)),
                          class: "agp-input",
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (deal.etapa = stagesOf(deal.funilId)[0]?.sequence ?? 1))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.funnels, (f) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: f.id,
                              value: f.id
                            }, _toDisplayString(f.name), 9, _hoisted_26))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, deal.funilId]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_27, [
                        _cache[41] || (_cache[41] = _createElementVNode("span", null, "Etapa", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "agp-deal-stage",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((deal.etapa) = $event)),
                          class: "agp-input"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stagesOf(deal.funilId), (s) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: s.id,
                              value: s.sequence
                            }, _toDisplayString(s.sequence) + ". " + _toDisplayString(s.name), 9, _hoisted_28))
                          }), 128))
                        ], 512), [
                          [
                            _vModelSelect,
                            deal.etapa,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_29, [
                        _cache[42] || (_cache[42] = _createElementVNode("span", null, "Valor (R$)", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "agp-deal-value",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((deal.valor) = $event)),
                          class: "agp-input",
                          inputmode: "decimal",
                          placeholder: "opcional"
                        }, null, 512), [
                          [_vModelText, deal.valor]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "agp-btn agp-btn--main",
                          disabled: busy.value || !deal.titulo.trim() || !deal.funilId
                        }, "Criar negócio", 8, _hoisted_31)
                      ])
                    ], 32))
                  : _createCommentVNode("", true),
                (!panel.value.deals.length && openForm.value !== 'deal')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, "Nenhum negócio ainda."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.deals, (d) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: d.id,
                    class: _normalizeClass(["agp-deal", `is-${d.status}`])
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("b", null, _toDisplayString(d.title), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["agp-pill", `pill-${d.status}`])
                      }, _toDisplayString(STATUS_LABEL[d.status]), 3)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createTextVNode(_toDisplayString([d.funnelName, d.stageName].filter(Boolean).join(' · ') || 'sem etapa'), 1),
                      (d.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · " + _toDisplayString(money(d.value)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (d.ownerName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" · " + _toDisplayString(d.ownerName), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    (d.status === 'ongoing' && d.funnelId)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "agp-stages",
                          "aria-label": `Etapas de ${d.title}`
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stagesOf(d.funnelId), (s) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: s.id,
                              type: "button",
                              class: _normalizeClass(["agp-stage", { done: (d.stageSequence ?? 0) > s.sequence, here: d.stageSequence === s.sequence }]),
                              disabled: busy.value || !canMove.value || d.stageSequence === s.sequence,
                              title: canMove.value ? `Mover para ${s.name}` : 'Sem permissão pra mover etapa (agendor.mover_etapa)',
                              onClick: ($event: any) => (doMove(d, s))
                            }, _toDisplayString(s.name), 11, _hoisted_36))
                          }), 128))
                        ], 8, _hoisted_35))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      (d.status === 'ongoing' && canWinLose.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "agp-btn agp-btn--sm agp-btn--won",
                              disabled: busy.value,
                              onClick: ($event: any) => (doStatus(d, 'won'))
                            }, "Marcar ganho", 8, _hoisted_38),
                            _createElementVNode("button", {
                              type: "button",
                              class: "agp-btn agp-btn--sm",
                              disabled: busy.value,
                              onClick: ($event: any) => (losing.value = losing.value === d.id ? null : d.id)
                            }, "Marcar perdido", 8, _hoisted_39)
                          ], 64))
                        : (d.status !== 'ongoing' && canWinLose.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "agp-btn agp-btn--sm",
                              disabled: busy.value,
                              onClick: ($event: any) => (doStatus(d, 'ongoing'))
                            }, "Reabrir", 8, _hoisted_40))
                          : _createCommentVNode("", true),
                      (d.webUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "agp-link",
                            href: d.webUrl,
                            target: "_blank",
                            rel: "noopener"
                          }, "Abrir ↗", 8, _hoisted_41))
                        : _createCommentVNode("", true)
                    ]),
                    (losing.value === d.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _withDirectives(_createElementVNode("select", {
                            id: `agp-loss-${d.id}`,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((lossReason).value = $event)),
                            class: "agp-input agp-grow",
                            "aria-label": "Motivo da perda"
                          }, [
                            _cache[43] || (_cache[43] = _createElementVNode("option", { value: "" }, "Motivo da perda…", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.lossReasons, (r) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: r.id,
                                value: r.id
                              }, _toDisplayString(r.name), 9, _hoisted_44))
                            }), 128))
                          ], 8, _hoisted_43), [
                            [_vModelSelect, lossReason.value]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "agp-btn agp-btn--sm agp-btn--danger",
                            disabled: busy.value || !lossReason.value,
                            onClick: ($event: any) => (doStatus(d, 'lost'))
                          }, "Confirmar", 8, _hoisted_45)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ], 512),
              _createElementVNode("section", {
                ref_key: "secTask",
                ref: secTask,
                class: "agp-sec"
              }, [
                _createElementVNode("div", _hoisted_46, [
                  _cache[44] || (_cache[44] = _createElementVNode("h3", null, "Retornos", -1)),
                  _createElementVNode("span", _hoisted_47, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "agp-link",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (openForm.value = openForm.value === 'task' ? null : 'task'))
                    }, _toDisplayString(openForm.value === 'task' ? 'Cancelar' : '+ Criar retorno'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "agp-link",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (openForm.value = openForm.value === 'note' ? null : 'note'))
                    }, _toDisplayString(openForm.value === 'note' ? 'Cancelar' : '+ Anotação'), 1)
                  ])
                ]),
                (openForm.value === 'task')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      class: "agp-form",
                      onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (doTask(true)), ["prevent"]))
                    }, [
                      _createElementVNode("label", _hoisted_48, [
                        _cache[45] || (_cache[45] = _createElementVNode("span", null, "Quando", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "agp-task-due",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((task.vencimento) = $event)),
                          class: "agp-input",
                          type: "datetime-local",
                          required: ""
                        }, null, 512), [
                          [_vModelText, task.vencimento]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_49, [
                        _cache[47] || (_cache[47] = _createElementVNode("span", null, "Tipo", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "agp-task-type",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((task.tipo) = $event)),
                          class: "agp-input"
                        }, [
                          _cache[46] || (_cache[46] = _createElementVNode("option", { value: "" }, "Tarefa", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AGENDOR_TASK_TYPES), (label, key) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: key,
                              value: key
                            }, _toDisplayString(label), 9, _hoisted_50))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, task.tipo]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_51, [
                        _cache[48] || (_cache[48] = _createElementVNode("span", null, "Para", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "agp-task-owner",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((task.responsavelId) = $event)),
                          class: "agp-input"
                        }, [
                          _createElementVNode("option", _hoisted_52, _toDisplayString(link.value.ownerName ? `Responsável do lead (${link.value.ownerName})` : 'Eu'), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.users, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.id,
                              value: u.id
                            }, _toDisplayString(u.name), 9, _hoisted_53))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, task.responsavelId]
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_54, [
                        _cache[49] || (_cache[49] = _createElementVNode("span", null, "O que fazer", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "agp-task-text",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((task.texto) = $event)),
                          class: "agp-input",
                          rows: "2",
                          required: ""
                        }, null, 512), [
                          [_vModelText, task.texto]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "agp-btn agp-btn--main",
                          disabled: busy.value || !task.texto.trim() || !task.vencimento
                        }, "Criar retorno", 8, _hoisted_56)
                      ])
                    ], 32))
                  : _createCommentVNode("", true),
                (openForm.value === 'note')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "agp-form",
                      onSubmit: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (doTask(false)), ["prevent"]))
                    }, [
                      _createElementVNode("label", _hoisted_57, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", null, "Anotação", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          id: "agp-note-text",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((note).value = $event)),
                          class: "agp-input",
                          rows: "3",
                          required: "",
                          placeholder: "Ex: pediu proposta pra 20 vagas de estágio"
                        }, null, 512), [
                          [_vModelText, note.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "agp-btn agp-btn--main",
                          disabled: busy.value || !note.value.trim()
                        }, "Registrar anotação", 8, _hoisted_59)
                      ])
                    ], 32))
                  : _createCommentVNode("", true),
                (!panel.value.openTasks.length && !openForm.value?.match(/task|note/))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_60, "Nenhum retorno em aberto."))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_61, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.value.openTasks, (t) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: t.id,
                      class: _normalizeClass({ late: t.dueAt && new Date(t.dueAt) < new Date() })
                    }, [
                      _createElementVNode("span", _hoisted_62, _toDisplayString(t.dueAt ? when(t.dueAt) : 'sem data'), 1),
                      _createElementVNode("span", _hoisted_63, [
                        _createTextVNode(_toDisplayString(t.text), 1),
                        (t.assignedNames.length)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_64, " · " + _toDisplayString(t.assignedNames.join(', ')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ])
              ], 512),
              _createElementVNode("section", {
                ref_key: "secOwner",
                ref: secOwner,
                class: "agp-sec"
              }, [
                _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Responsável", -1)),
                _createElementVNode("p", _hoisted_65, _toDisplayString(link.value.ownerName ? `Hoje: ${link.value.ownerName}` : 'Sem responsável no Agendor.'), 1),
                _createElementVNode("div", _hoisted_66, [
                  (panel.value.myUserId && link.value.ownerName !== myName.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "agp-btn agp-btn--main",
                        disabled: busy.value,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (doOwner(null)))
                      }, "Assumir lead", 8, _hoisted_67))
                    : (!panel.value.myUserId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Seu usuário no Agendor não está definido (Admin › Agendor)."))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _withDirectives(_createElementVNode("select", {
                    id: "agp-pass-to",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((passTo).value = $event)),
                    class: "agp-input agp-grow",
                    "aria-label": "Passar lead para"
                  }, [
                    _cache[51] || (_cache[51] = _createElementVNode("option", { value: "" }, "Passar lead para…", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherUsers.value, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.id,
                        value: u.id
                      }, _toDisplayString(u.name), 9, _hoisted_70))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, passTo.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "agp-btn",
                    disabled: busy.value || !passTo.value,
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (doOwner(passTo.value)))
                  }, "Passar", 8, _hoisted_71)
                ])
              ], 512)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (link.value)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_72, [
            (link.value.webUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "agp-btn",
                  href: link.value.webUrl,
                  target: "_blank",
                  rel: "noopener"
                }, "Ver no Agendor ↗", 8, _hoisted_73))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "agp-btn",
              disabled: busy.value || __props.state.loading.value,
              onClick: doRefresh
            }, _toDisplayString(__props.state.loading.value ? 'Atualizando…' : 'Atualizar'), 9, _hoisted_74),
            _createElementVNode("button", {
              type: "button",
              class: "agp-btn agp-btn--danger",
              disabled: busy.value,
              onClick: doUnlink
            }, "Desvincular", 8, _hoisted_75)
          ]))
        : _createCommentVNode("", true)
    ], 544)
  ]))
}
}

})